import { GenericTestRouteState } from './generic-test-state'

export const SummaryTestRouteState = GenericTestRouteState.named(
  'SummaryTestRouteState'
)
